import type { ReactNode } from 'react'
import { RouterProvider as ReactRouterProvider } from 'react-router-dom'

import type { Router } from './Types'

export function RouterProvider({
  router,
  fallbackElement = null,
}: {
  router: Router
  /** Optional suspense fallback; pass a LoadingOverlay from the app/ui layer. */
  fallbackElement?: ReactNode
}) {
  return (
    <ReactRouterProvider router={router} fallbackElement={fallbackElement} />
  )
}
